"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAnswer = instanceOfAnswer;
exports.AnswerFromJSON = AnswerFromJSON;
exports.AnswerFromJSONTyped = AnswerFromJSONTyped;
exports.AnswerToJSON = AnswerToJSON;
exports.AnswerToJSONTyped = AnswerToJSONTyped;
/**
 * Check if a given object implements the Answer interface.
 */
function instanceOfAnswer(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
function AnswerFromJSON(json) {
    return AnswerFromJSONTyped(json, false);
}
function AnswerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'email': json['email'],
    };
}
function AnswerToJSON(json) {
    return AnswerToJSONTyped(json, false);
}
function AnswerToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'email': value['email'],
    };
}
//# sourceMappingURL=Answer.js.map